//Use this for showing date on UI

const convertDateToLocal = (dateInput, dateFormat) => {
  if (dateInput == null) return "invalid date";

  let dateValue = new Date(dateInput + "Z").toLocaleDateString("hi-IN"); //.toLocaleString('hi-IN');
  let DateArray = dateValue.split("/");

  let day = DateArray[0]?.padStart(2, "0");
  let month = DateArray[1]?.padStart(2, "0");
  let year = DateArray[2];

  // let day = dateValue.getDate().toString().padStart(2, '0');
  // let month = (dateValue.getMonth() + 1).toString().padStart(2, '0');
  // let year = dateValue.getFullYear();

  if (dateFormat === "dd-MM-yyyy") {
    return `${day}-${month}-${year}`;
  } else if (dateFormat === "MM-dd-yyyy") {
    return `${month}-${day}-${year}`;
  } else if (dateFormat === "yyyy-MM-dd") {
    return `${year}-${month}-${day}`;
  } else {
    return `${day}-${month}-${year}`;
  }

  // Default to 'yyyy-mm-dd' if dateFormat is not recognized
  // return `${year}-${month}-${day}`;
};

//Use this for showing date in textfield on UI (use this for forms add & edit)
const convertDateToLocalReverse = (dateInput) => {
  let dateValue = new Date(dateInput); //.toLocaleString('hi-IN');
  let day = dateValue.getDate().toString()?.padStart(2, "0");
  let month = (dateValue.getMonth() + 1).toString()?.padStart(2, "0");
  let year = dateValue.getFullYear();
  return `${year}-${month}-${day}`;
};

const getDateDifference = (date1, date2) => {
  let date_1 = new Date(date1);
  let date_2 = new Date(date2);
  let diffTime = date_1 - date_2;
  let diff = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1;
  return diff;
};

// const addDays = (date, days) => {
//   var date = new Date(date);
//   date.setDate(date.getDate() + days);
//   return date;
// };

// Use this for showing datetime on UI — output: "25-04-2026 10:30 AM"
// Parses as-is with no timezone conversion (stored value is already local time)
const convertDateTimeToLocal = (dateInput) => {
  if (dateInput == null) return "invalid date";

  const str = dateInput.toString();
  const [datePart, timePart = "00:00"] = str.split("T");
  const [year, month, day] = datePart.split("-");
  const [hoursRaw, minutesRaw = "00"] = timePart.split(":");

  let hours = parseInt(hoursRaw, 10);
  const minutes = minutesRaw.substring(0, 2).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
};

// Use this for datetime fields in forms (datetime-local input expects "YYYY-MM-DDTHH:MM")
const convertDateTimeToLocalReverse = (dateInput) => {
  if (dateInput == null) return "";
  // String from backend e.g. "2026-04-26T10:30:00" — just slice
  if (typeof dateInput === "string") return dateInput.slice(0, 16);
  // Date object (e.g. new Date()) — format in local time
  const d = new Date(dateInput);
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  const hours = d.getHours().toString().padStart(2, "0");
  const minutes = d.getMinutes().toString().padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export {
  convertDateToLocal,
  convertDateToLocalReverse,
  getDateDifference,
  convertDateTimeToLocal,
  convertDateTimeToLocalReverse,
};
